import {trackEvent} from '@jetbrains/teamcity-ui/statistics'

import type {BuildId} from '../../../../types'
import {stringifyId} from '../../../../types'

const GROUP_ID = 'build.expand.events.group'

const expandTimestamps = new Map<string, number>()

type NavigationTarget =
  | 'direct_build_link'
  | 'build_tab'
  | 'build_problem'
  | 'failed_test'
  | 'other'

type BuildNavigationClickData = {
  usedExpand: string
  timeFromExpandMs?: string
  targetType: NavigationTarget
}

const trackBuildExpandEvent = (eventName: string, data?: BuildNavigationClickData) => {
  trackEvent({
    name: eventName,
    groupId: GROUP_ID,
    data,
  })
}

export const trackBuildExpandOpen = (buildId: BuildId) => {
  expandTimestamps.set(stringifyId(buildId), Date.now())
  trackBuildExpandEvent('build.expand.open')
}

export const clearExpandTimestamp = (buildId: BuildId) => {
  expandTimestamps.delete(stringifyId(buildId))
}

export const trackBuildNavigationClick = ({
  buildId,
  targetType,
  isExpanded,
}: {
  buildId: BuildId | null | undefined
  targetType: NavigationTarget
  isExpanded: boolean
}) => {
  if (buildId == null) {
    return
  }
  const key = stringifyId(buildId)
  const expandTimestamp = expandTimestamps.get(key)
  const usedExpand = isExpanded && expandTimestamp != null
  const timeFromExpandMs = usedExpand ? Date.now() - expandTimestamp : undefined

  const data: BuildNavigationClickData = {
    usedExpand: String(usedExpand),
    targetType,
    ...(timeFromExpandMs != null && {timeFromExpandMs: String(timeFromExpandMs)}),
  }

  trackBuildExpandEvent('build.navigation.click', data)
}
